import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
  } from "@mui/material";
  import WarningAmberIcon from "@mui/icons-material/WarningAmber"; // Ícone de alerta
  import LocalHospitalIcon from "@mui/icons-material/LocalHospital"; // Ícone para UBS
  import AssignmentIndIcon from "@mui/icons-material/AssignmentInd"; // Ícone para Número do SUS
  
  const ModalAvisoSUSUBS = ({ open, onClose, onContinue, missingFields }) => {
    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <WarningAmberIcon sx={{ color: "#FFA000", fontSize: 30 }} />
          <Typography variant="h6" fontWeight="bold" color="#333">
            Atenção!
          </Typography>
        </DialogTitle>
  
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
            O cadastro pode ser feito sem essas informações, mas recomendamos que
            você procure a UBS ou a Secretaria para obtê-las. Você poderá editar
            esses dados posteriormente na atualização cadastral.
          </Typography>
  
          {/* Exibe a lista do que está faltando */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            {missingFields.includes("sus") && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <AssignmentIndIcon sx={{ color: "#D32F2F" }} />
                <Typography variant="body2" color="textSecondary">
                  Número do SUS não informado.
                </Typography>
              </Box>
            )}
            {missingFields.includes("ubs") && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <LocalHospitalIcon sx={{ color: "#D32F2F" }} />
                <Typography variant="body2" color="textSecondary">
                  UBS (Unidade Básica de Saúde) não informada.
                </Typography>
              </Box>
            )}
          </Box>
        </DialogContent>
  
        <DialogActions sx={{ pb: 2, pr: 3 }}>
          <Button onClick={onContinue} variant="contained" color="primary">
            Continuar sem SUS/UBS
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  
  export default ModalAvisoSUSUBS;
  